// extracted by css-extract-rspack-plugin
module.exports =  {"moreButton":"DocumentsCard__moreButton___BrfLh"};